import { useAdminUpdate } from '@reapitform/hooks'
import { AdminReviewCard, AdminReviewCardPayload } from '../types'

/** Updates a review card (`PUT …/versions/{versionRef}/review-cards/{reviewCardRef}`). */
export const useUpdateAdminReviewCard = (
  formReferenceID: string,
  versionReferenceID: string,
  reviewCardReferenceID: string,
) =>
  useAdminUpdate<AdminReviewCardPayload, AdminReviewCard>({
    path: `/api/forms/${formReferenceID}/versions/${versionReferenceID}/review-cards/${reviewCardReferenceID}`,
    method: 'PUT',
    errorMessage: 'Failed to update the review card',
    successMessage: 'Review card updated',
  })
